import { render } from "./TrainingListPage.vue?vue&type=template&id=429abc94"
import script from "./TrainingListPage.vue?vue&type=script&lang=js"
export * from "./TrainingListPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__